import type React from 'react';

interface DinersCardDarkIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function DinersCardDarkIcon({ size = 24, ...props }: DinersCardDarkIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8664_25221)">
        <path
          d="M2.62496 0.800049H39.375C40.8241 0.800049 42 1.94527 42 3.35769V27.6437C42 29.0548 40.8241 30.2 39.375 30.2H2.62496C1.17465 30.2002 0 29.0548 0 27.6438V3.35769C0 1.94527 1.17594 0.800049 2.62496 0.800049Z"
          fill="#0079BE"
        />
        <path
          d="M23.1792 24.9499C28.3329 24.9747 33.037 20.7372 33.037 15.5821C33.037 9.94478 28.3329 6.04817 23.1792 6.05005H18.7437C13.5282 6.04817 9.23532 9.94594 9.23532 15.5821C9.23532 20.7383 13.5282 24.9747 18.7437 24.9499H23.1792Z"
          fill="white"
        />
        <path
          d="M18.7643 6.8302C13.9985 6.8317 10.1366 10.7036 10.1355 15.4822C10.1366 20.26 13.9985 24.1315 18.7643 24.133C23.5312 24.1315 27.3939 20.26 27.3945 15.4822C27.3938 10.7036 23.5312 6.8317 18.7643 6.8302ZM13.2947 15.4822C13.2992 13.1471 14.7543 11.1558 16.806 10.3646V20.5986C14.7543 19.8078 13.2992 17.8176 13.2947 15.4822ZM20.7218 20.6009V10.3642C22.7743 11.1536 24.2316 13.146 24.2353 15.4822C24.2316 17.8191 22.7743 19.81 20.7218 20.6009Z"
          fill="#0079BE"
        />
      </g>
      <defs>
        <clipPath id="clip0_8664_25221">
          <rect y="0.800049" width="42" height="29.4" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
